<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='12'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <el-row>
            <el-col :span="2"><el-button type="primary" size="mini" round plain @click="Createtask()">创建信息</el-button></el-col>
          </el-row>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row>
              <el-col :span="8">
                <el-cascader v-model="company" :options="companyList" clearable filterable :props="{ value: 'id',label: 'name', checkStrictly: true }"  style="width: 100%;" placeholder="请选择厂区" @change="afreshData()" size="small"></el-cascader>
              </el-col>
              <el-col :span="3">
                <el-select v-model="listQuery.pay_state" size="small" clearable placeholder="选择支付方式" style="margin-left: 20px;" @change="selectNewDate()">
                  <el-option label="对公打款" value="1"></el-option>
                  <el-option label="现金支付" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select v-model="listQuery.pay_source" size="small" clearable placeholder="选择购买来源" style="margin-left: 20px;" @change="selectNewDate()">
                  <el-option label="淘宝" value="1"></el-option>
                  <el-option label="本地" value="2"></el-option>
                  <el-option label="京东" value="3"></el-option>
                  <el-option label="西域" value="4"></el-option>
                  <el-option label="震坤行" value="5"></el-option>
                  <el-option label="微信" value="6"></el-option>
                  <el-option label="旺旺" value="7"></el-option>
                  <el-option label="其他" value="8"></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select v-model="listQuery.invoice" size="small" clearable placeholder="选择发票类型" style="margin-left: 20px;" @change="selectNewDate()">
                  <el-option label="专票" value="1"></el-option>
                  <el-option label="普票" value="2"></el-option>
                  <el-option label="无" value="3"></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select v-model="listQuery.return_invoice" size="small" clearable placeholder="是否回票" style="margin-left: 20px;" @change="selectNewDate()">
                  <el-option label="已回票" value="已回票"></el-option>
                  <el-option label="未回票" value="未回票"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2">
                <div style="padding-top:5px;padding-left:155px;">
                  <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="operationManual"></i>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="7" style="margin-bottom:10px;margin-top: 10px;">
                <el-date-picker
                  v-model="addtimeBTTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="selectOperationTime"
                  size="small"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="8" style="margin-top: 14px;">
                <em style="font-size:14px;font-weight:bold;font-style:normal;color: #409eff;">总计：</em>
                <count-to :start-val="0" :end-val="amount" :duration="2600" :decimals="2" class="card-panel-num" style="color:#ff4949;font-weight:bold;font-size:14px;" />
              </el-col>
            </el-row>
            <el-row style="position: static;">
              <el-col :span="24" class="task">
                <el-table :data="list" border v-loading="qyloading" style="width: 100%" @header-click="dandian">
                  <el-table-column label="日期" align="center" :fixed="isFixed[10]"  :index="10" width="100">
                    <template slot-scope="scope">
                      <span>{{ scope.row.addtime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="采买配件名称" align="center" :fixed="isFixed[11]" width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{ scope.row.parets_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="单位" align="center" width="60" :fixed="isFixed[0]" :index="0">
                    <template slot-scope="scope">
                      <span>{{ scope.row.units }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量" align="center" :fixed="isFixed[1]" :index="1">
                    <template slot-scope="scope">
                      <span>{{ scope.row.number }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="单价" align="center" :fixed="isFixed[2]" :index="2">
                    <template slot-scope="scope">
                      <span>{{ scope.row.price }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="总价" align="center" :fixed="isFixed[3]" :index="3">
                    <template slot-scope="scope">
                      <span style="font-weight: bold;color: #ea4343;">{{ (scope.row.number*scope.row.price).toFixed(2) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="支付方式" width="120" :fixed="isFixed[4]" :index="4">
                    <template slot-scope="{row}">
                      <!-- <el-select v-model="row.pay_state" size="mini" placeholder="请选择" @change="changeState(row)">
                        <el-option label="对公打款" value="1"></el-option>
                        <el-option label="现金支付" value="2"></el-option>
                      </el-select> -->
                      <span v-if="row.pay_state === '1'">对公打款</span>
                      <span v-if="row.pay_state === '2'">现金支付</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="厂区" align="center" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-popover trigger="hover" placement="top">
                        <p>{{ scope.row.companyName }}</p>
                        <div slot="reference" class="name-wrapper">
                          <span>{{ scope.row.plantName }}</span>
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="是否回票" width="110" :fixed="isFixed[7]" :index="7">
                    <template slot-scope="{row}">
                      <!-- <el-select v-model="row.return_invoice" size="mini" placeholder="请选择" @change="changeinvoice(row)">
                        <el-option label="已回票" value="已回票"></el-option>
                        <el-option label="未回票" value="未回票"></el-option>
                      </el-select> -->
                      <el-switch
                        style="display: block"
                        v-model="row.return_invoice"
                        active-value="已回票"
                        inactive-value="未回票"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="changeinvoice(row)"
                        active-text="是"
                        inactive-text="否">
                      </el-switch>
                      <!-- <span v-if="row.return_invoice === '已回票'">已回票</span>
                      <span v-if="row.return_invoice === '未回票'" style="color: rgb(255, 73, 73);">未回票</span> -->
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="购买来源" width="110" :fixed="isFixed[5]" :index="5">
                    <template slot-scope="{row}">
                      <!-- <el-select v-model="row.pay_source" size="mini" placeholder="请选择" @change="changeState(row)">
                        <el-option label="淘宝" value="1"></el-option>
                        <el-option label="本地" value="2"></el-option>
                        <el-option label="京东" value="3"></el-option>
                        <el-option label="西域" value="4"></el-option>
                        <el-option label="震坤行" value="5"></el-option>
                        <el-option label="其他" value="6"></el-option>
                      </el-select> -->
                      <span v-if="row.pay_source === '1'">淘宝</span>
                      <span v-if="row.pay_source === '2'">本地</span>
                      <span v-if="row.pay_source === '3'">京东</span>
                      <span v-if="row.pay_source === '4'">西域</span>
                      <span v-if="row.pay_source === '5'">震坤行</span>
                      <span v-if="row.pay_source === '6'">微信</span>
                      <span v-if="row.pay_source === '7'">旺旺</span>
                      <span v-if="row.pay_source === '8'">其他</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="发票" width="100" :fixed="isFixed[6]" :index="6">
                    <template slot-scope="{row}">
                      <!-- <el-select v-model="row.invoice" size="mini" placeholder="请选择" @change="changeState(row)">
                        <el-option label="专票" value="1"></el-option>
                        <el-option label="普票" value="2"></el-option>
                        <el-option label="无" value="3"></el-option>
                      </el-select> -->
                      <span v-if="row.invoice === '1'">专票</span>
                      <span v-if="row.invoice === '2'">普票</span>
                      <span v-if="row.invoice === '3'">无</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="来源信息" align="center" show-overflow-tooltip  width="150" :fixed="isFixed[8]" :index="8">
                    <template slot-scope="scope">
                      <!-- <a :href="scope.row.pay_address" target="_blank" class="link-type"> -->
                        <span>{{ scope.row.pay_address }}</span>
                      <!-- </a> -->
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" align="center" show-overflow-tooltip width="200" :fixed="isFixed[9]" :index="9">
                    <template slot-scope="scope">
                      <span>{{ scope.row.remark }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center"  fixed="right">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                      >
                        <p>确定删除该产品吗？</p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="expenseDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                        <ul>
                          <li v-for="(item,index) in scopes.row.voucher" :key="index" style="padding: 8px 15px 8px;">
                            <span>{{ item.name }}</span>
                            <el-button type="primary" plain size="mini" style="float: right;" @click="dowloadFile(item.response)">下载</el-button>
                          </li>
                        </ul>
                        <el-button v-if="scopes.row.voucher" slot="reference" size="mini" type="text">凭证文件</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="采购信息" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="22">
            <el-form-item label="订单列表">
              <el-cascader v-model="form.businessOrdersList" :options="businessOrdersList" clearable filterable :props="{ value: 'id',label: 'name' }" style="width: 100%;" @change="handleChange"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="厂区" prop="companyList">
              <el-cascader v-model="form.companyList" :options="companyList" clearable filterable :props="{ value: 'id',label: 'name' }" style="width: 100%;"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="采购描述" prop="parets_name">
              <el-input v-model="form.parets_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="产品分类" prop="parets_name">
              <el-cascader v-model="form.cateList" :options="cateList" clearable filterable :props="{ value: 'id',label: 'title' }" style="width: 100%;"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="单位" prop="units">
              <el-input v-model="form.units"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="数量" prop="number">
              <el-input-number v-model="form.number" size="small" :precision="2" :min="0" :step="1" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单价" prop="price">
              <!-- <el-input v-model="form.price"></el-input> -->
              <el-input-number v-model="form.price" size="small" :precision="2" :min="0" :step="1" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="总价">
              <span style="font-weight: bold;color: #ea4343;">{{ (form.number*form.price).toFixed(2) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="支付方式" prop="pay_state">
              <el-select v-model="form.pay_state" placeholder="请选择支付方式">
                <el-option label="对公打款" value="1"></el-option>
                <el-option label="现金支付" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="7" v-if="form.pay_state === '2'">
            <el-form-item label="">
              <el-checkbox v-model="form.buy_type">纳入账单支付</el-checkbox>
            </el-form-item>
          </el-col> -->
          <el-col :span="7">
            <el-form-item label="购买来源" prop="pay_source">
              <el-select v-model="form.pay_source" placeholder="请选择购买来源">
                <el-option label="淘宝" value="1"></el-option>
                <el-option label="本地" value="2"></el-option>
                <el-option label="京东" value="3"></el-option>
                <el-option label="西域" value="4"></el-option>
                <el-option label="震坤行" value="5"></el-option>
                <el-option label="微信" value="6"></el-option>
                <el-option label="旺旺" value="7"></el-option>
                <el-option label="其他" value="8"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申购人">
              <el-input v-model="form.requisitioner" placeholder="请输入申购人"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="来源信息" prop="pay_address">
              <el-input v-model="form.pay_address" type="textarea" :rows="4"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发票类型" prop="invoice">
              <el-select v-model="form.invoice" placeholder="请选择发票类型">
                <el-option label="专票" value="1"></el-option>
                <el-option label="普票" value="2"></el-option>
                <el-option label="无" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="是否回票" prop="return_invoice">
              <el-radio-group v-model="form.return_invoice" size="mini">
                <el-radio-button label="已回票" value="已回票"></el-radio-button>
                <el-radio-button label="未回票" value="未回票"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="采购时间" required>
              <el-form-item prop="addtime">
                <el-date-picker type="date" placeholder="选择日期" v-model="form.addtime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" :rows="4" v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="上传文件" prop="img">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="upload_url"
                :on-success="handlesuccess"
                :on-remove="removeUpload"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx,.docx,.doc,.jpg,.pdf,.zip,.rar"
                :file-list="myfileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="true"
              >
                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>
    <el-image
      style="width: 0px; height: 0px"
      src="https://serv.nmzp.com/uploads/1/image/20240411/061e6fd50a7666ee73101bbd50414bda.jpg"
      :lazy="true"
      ref="preview"
      :preview-src-list="srcList"
    >
    </el-image>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/expense'
import busOrders from '@/api/businessOrders'
import CountTo from 'vue-count-to'
import apiConfig from '../../../config/api.config.js'
import { getToken } from '@/utils/auth'

export default {
  name: 'ExpenseAccount',
  mixins: [vuelist],
  components: { Top, LeftNav, Bottom, Pagination, CountTo },
  data () {
    return {
      api,
      srcList: ['https://serv.nmzp.com/uploads/1/image/20240411/061e6fd50a7666ee73101bbd50414bda.jpg', 'https://serv.nmzp.com/uploads/1/image/20240411/58a0fc4a46e2f1bb9b7d3dfe1499a333.jpg'],
      businessOrdersList: [],
      companyList: [],
      company: [],
      listQuery: {
        limit: 10,
        page: 1,
        order: 'addtime'
      },
      isFixed: { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 9: false, 10: true, 11: false },
      qyloading: false,
      dialogFormVisible: false,
      locktype: false,
      cateList: [],
      form: {
        businessOrdersList: [],
        companyList: [],
        parets_name: '',
        units: '',
        number: '',
        price: '',
        pay_state: '',
        pay_source: '',
        pay_address: '',
        invoice: '',
        return_invoice: '未回票',
        addtime: '',
        remark: '',
        requisitioner: '',
        cateList: []
      },
      amount: 0.00,
      rules: {
        companyList: [{ required: true, message: '请选择厂区', trigger: 'blur' }],
        parets_name: [{ required: true, message: '请输入采购描述', trigger: 'blur' }],
        units: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        number: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        pay_state: [{ required: true, message: '请选择支付方式', trigger: 'blur' }],
        pay_source: [{ required: true, message: '请选择购买来源', trigger: 'blur' }],
        invoice: [{ required: true, message: '请选择发票类型', trigger: 'blur' }],
        addtime: [{ required: true, message: '请选择采购时间', trigger: 'blur' }],
        pay_address: [{ required: true, message: '请输入产品来源信息', trigger: 'blur' }]
      },
      addtimeBTTime: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dialogVisible: false,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_workdiary',
      requestHeaders: {
        'X-Token': getToken()
      },
      myfileList: []
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.LoadData()
    this.getBusinessOrdersList()
    this.getCompanyList()
    this.getcateGoods()
  },
  methods: {
    getCompanyList () {
      api.getCompanyList().then(response => {
        this.companyList = response.message
      })
    },
    Createtask () {
      this.dialogFormVisible = true
      this.locktype = false
      this.form = {
        businessOrdersList: [],
        companyList: [],
        parets_name: '',
        units: '',
        number: '',
        price: '',
        pay_state: '',
        pay_source: '',
        pay_address: '',
        invoice: '',
        return_invoice: '未回票',
        addtime: '',
        remark: '',
        requisitioner: ''
      }
    },
    submitForm () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            return false
          }
          this.locktype = true
          this.form.voucher = this.myfileList
          api.submitForm(this.form).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.LoadData()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.form = Object.assign({}, row)
      this.form.companyList = [row.group_list_id, row.company_id, row.plant_id]
      this.form.cateList = [row.category_grand_id, row.category_parent_id]
      this.form.businessOrdersList = [row.business_orders_goods_id]
    },
    expenseDelete (row, index, scopes) {
      api.expenseDelete({ id: row.id }).then(response => {
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
        this.LoadData()
      })
    },
    selectNewDate () {
      this.listQuery.page = 1
      this.LoadData()
    },
    afreshData () {
      this.listQuery.page = 1
      if (this.company.length === 1) {
        this.listQuery.group_list_id = this.company[0]
        this.listQuery.company_id = null
        this.listQuery.plant_id = null
      } else if (this.company.length === 2) {
        this.listQuery.group_list_id = this.company[0]
        this.listQuery.company_id = this.company[1]
        this.listQuery.plant_id = null
      } else if (this.company.length === 3) {
        this.listQuery.group_list_id = this.company[0]
        this.listQuery.company_id = this.company[1]
        this.listQuery.plant_id = this.company[2]
      }
      this.LoadData()
    },
    selectOperationTime () {
      if (this.addtimeBTTime) {
        this.listQuery.addtimeBTTime = this.addtimeBTTime
      } else {
        this.listQuery.addtimeBTTime = []
      }
      this.LoadData()
    },
    LoadData () {
      this.qyloading = true // 页面区域loading
      this.isLoading = true
      this.api.Query(this.listQuery).then(response => {
        this.list = response.items
        this.total = response.total
        this.amount = response.amount
        this.isLoading = false
        this.qyloading = false
      })
    },
    dandian (column, event) {
      this.isFixed[column.index] = !this.isFixed[column.index]
    },
    operationManual () {
      this.$nextTick(() => {
        this.$refs.preview.clickHandler()
      })
    },
    changeinvoice (state) {
      api.changeinvoice(state).then((response) => {
        this.$notify({ title: '成功', message: response.message, type: 'success', duration: 2000 })
      })
    },
    removeUpload (file, fileList) {
      this.myfileList = fileList
    },
    handlesuccess (response, file, fileList) {
      if (response.code === 20000) {
        this.myfileList = fileList
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const extension3 = testmsg === 'docx'
      const extension4 = testmsg === 'doc'
      const extension5 = testmsg === 'jpg'
      const extension6 = testmsg === 'pdf'
      const extension7 = testmsg === 'zip'
      const extension8 = testmsg === 'rar'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6 && !extension7 && !extension8) {
        this.$message({
          message: '上传文件只能是 xls、xlsx、docx、doc、jpg、pdf、zip、rar格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      return (extension || extension2 || extension3 || extension4 || extension5 || extension6 || extension7 || extension8) && isLt2M
    },
    getBusinessOrdersList () {
      busOrders.getScreenBusOrdersList({user_id: this.current_user.id}).then(response => {
        this.businessOrdersList = response.message
      })
    },
    // 查询信息回调
    handleChange (value) {
      busOrders.getBusOrdersQueryData({BusOrdersArr: value}).then(response => {
        if (response.code === 20000) {
          // 厂区
          this.form.companyList = response.data.companyList
          // 采购描述
          this.form.parets_name = response.data.material_des
          // 单位
          this.form.units = response.data.units
          // 数量
          this.form.number = response.data.number
          // 单价
          this.form.price = response.data.tax_price
          // 备注
          this.form.remark = '采购订单号：' + response.data.purchase_order_num + '\n物料编码：' + response.data.material_code
        }
      })
    },
    dowloadFile (urlFile) {
      window.open(urlFile.message, '_blank')
    },
    getcateGoods () {
      api.getcateGoods().then(res => {
        this.cateList = res.data
      })
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 40px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 85%;
}
.el-image >>> .el-image-viewer__close{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/member/expense_account.vue